import { Injectable } from '@angular/core';
import { FrameContext } from '@farris/devkit';
import { ListFilterHandler, QueryCondition } from '@farris/ui-list-filter';

@Injectable()
export class ListFilterConditionsService implements ListFilterHandler {
  constructor(private frameContext: FrameContext) { }
  public setCurrentFilterConditions(conditions: QueryCondition[]): void {
    this.frameContext.uiState['currentFilterConditions'] = conditions;
  }
}
